import { useState, useCallback } from 'react'

export const usePip = ( setWebinarPipWindow ) => {
    const [pipWindow, setPipWindow] = useState( null )

    const enterPipMode = useCallback( async ( onClose ) => {
        if ( !window.documentPictureInPicture ) {
            console.warn( "Document PiP is not supported in this browser." )
            return null
        }

        try {
            const width = 350
            const height = Math.round( ( width * 16 ) / 9 )

            const windowInstance = await window.documentPictureInPicture.requestWindow( {
                width,
                height,
            } );

            // Copy Styles from main document to PiP document
            [...document.styleSheets].forEach( ( styleSheet ) => {
                try {
                    const cssRules = [...styleSheet.cssRules].map( ( rule ) => rule.cssText ).join( "" )
                    const style = document.createElement( "style" )
                    style.textContent = cssRules
                    windowInstance.document.head.appendChild( style )
                } catch ( e ) {
                    const link = document.createElement( "link" )
                    link.rel = "stylesheet"
                    link.href = styleSheet.href
                    windowInstance.document.head.appendChild( link )
                }
            } )

            windowInstance.addEventListener( "pagehide", () => {
                setPipWindow( null )
                if ( onClose ) {
                    onClose( null )
                    setWebinarPipWindow( null )
                }
            } )

            setWebinarPipWindow( windowInstance )
            setPipWindow( windowInstance )
            return windowInstance
        } catch ( err ) {
            console.error( "Failed to enter PiP mode:", err )
            return null
        }
    }, [setWebinarPipWindow] )

    const closePip = useCallback( () => {
        if ( pipWindow ) {
            pipWindow.close()
            setPipWindow( null )
            setWebinarPipWindow( null )
        }
    }, [pipWindow, setWebinarPipWindow] )

    return { pipWindow, enterPipMode, closePip }
}